var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"swiper",on:{"mouseenter":_vm.showSwipe,"mouseleave":_vm.closeSwipe}},[_c('div',{staticClass:"swiper-wrapper"},[_vm._t("default")],2),_c('div',{staticClass:"swiper-pagination",attrs:{"slot":"pagination"},slot:"pagination"})])
}
var staticRenderFns = []

export { render, staticRenderFns }